import React, { useState, useContext, createContext } from 'react';

const SearchInquiresContext = createContext();

export const SearchInquiresProvider = ({ children }) => {
  const defaultStartTime = new Date();
  defaultStartTime.setMonth(defaultStartTime.getMonth() - 3);

  const [searchInquires, setSearchInquires] = useState({
    msgType: '',
    contactId: '',
    agentName: '',
    startDate: defaultStartTime,
    status: '',
    inquires: [],
  });

  return (
    <SearchInquiresContext.Provider value={{ searchInquires, setSearchInquires }}>
      {children}
    </SearchInquiresContext.Provider>
  );
};

// Custom Hook
export const useSearchInquiresContext = () => {
  return useContext(SearchInquiresContext);
};

export default SearchInquiresContext;